import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { setSideBarColors } from "../../../Theme/ThemeHelper";
import biClient from "../../../../apis/businessIntelligenceClient";
import channelClient from "../../../../apis/channelClient";
import sitemapAPI from "../../../../apis/sitemap";
import SntLabIcon from "@icons/SntLabIcon";
import useAvailibleMenu from "./useAvailibleMenu";
import MenuType from "./menuTypeConst";

const useMainMenu = (loginInfo, onMenuChange = () => {}) => {
  const global = useSelector((state) => state.all);
  const { features, permissionsMap, custumInfo, organisation } = loginInfo;
  const language = useSelector((state) => state.language);

  const initialRoutes = [
    {
      view:
        features.utilization_suez ||
        (features.dashboard && permissionsMap["MENU_HOME_DASHBOARD"]),
      collapse: true,
      name: language.UserPermission_MENU_HOME_DASHBOARD_description_key,
      state: "openDashboards",
      icon: <span className="dashboard-menu-icon menu-icon"></span>,
      views: [],
    },
    {
      collapse: true,
      name: language.assets_key,
      state: "openAssets",
      icon: <span className="assets-menu-icon menu-icon"></span>,
      views: [
        {
          view: features.loc_map && permissionsMap["MENU_HOME_ASSET_MAP"],
          to: "/assets_location",
          layout: "",
          name: language.UserPermission_MENU_HOME_ASSET_MAP_description_key,
        },
        {
          view: permissionsMap["MENU_HOME_ASSET_LIST"],
          to: "/tracked_assets",
          layout: "",
          name: language.UserPermission_MENU_HOME_ASSET_LIST_description_key,
          subPages: ["/tracked_assets_update"],
        },
        {
          view: permissionsMap["MENU_HOME_TAGS"],
          to: "/asset_tags_manage_admin",
          layout: "",
          name: language.UserPermission_MENU_HOME_TAGS_description_key,
        },
        {
          view: permissionsMap["MANUFACTURING"],
          to: "/manufacturing_info_view",
          layout: "",
          name: language.manufacturing_history_key,
        },
        {
          view:
            features["location_history"] &&
            permissionsMap["MENU_HOME_LOCATION_HISTORY"],
          to: "/location_history",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_LOCATION_HISTORY_description_key,
        },
      ],
    },
    {
      collapse: true,
      name: language.site_maps_key,
      state: "openSiteMaps",
      icon: <span className="site-maps-menu-icon menu-icon"></span>,
      views: [
        {
          view:
            features["loc_site_map"] && permissionsMap["MENU_HOME_SITE_MAP"],
          to: "/all_site_maps",
          layout: "",
          name: language.all_site_maps_key,
          subPages: ["/site_map_view"],
        },
      ],
    },
    {
      collapse: true,
      name: language.geozones_key,
      state: "openGeozone",
      icon: <span className="geozones-menu-icon menu-icon"></span>,
      views: [
        {
          view:
            features.geozone_db && permissionsMap["MENU_HOME_GEOZONE_OVERVIEW"],
          to: "/geozones_dashboard",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_GEOZONE_OVERVIEW_description_key,
        },
        {
          view:
            features.geozone_list && permissionsMap["MENU_HOME_GEOZONE_LIST"],
          to: "/geozones_list",
          layout: "",
          name: language.UserPermission_MENU_HOME_GEOZONE_LIST_description_key,
          subPages: ["/geozone_individual"],
        },
        {
          view:
            features.geozone_taglist &&
            permissionsMap["MENU_HOME_GEOZONE_TAGS"],
          to: "/geozones_tag_list",
          layout: "",
          name: language.UserPermission_MENU_HOME_GEOZONE_TAGS_description_key,
        },
        {
          view:
            permissionsMap["MENU_HOME_GEOZONE_VISIT_LIST"] &&
            features.geozone_visit,
          to: "/geozonevisit_list",
          layout: "",
          name: language.featurecategory_geozone_visits_name,
        },
      ],
    },
    {
      collapse: true,
      name: language.sidebar_assets_utilization_key,
      state: "openUtilization",
      icon: <span className="utilization-active-menu-icon menu-icon"></span>,
      views: [
        {
          view:
            organisation?.organisationType !== "SYSTEM" &&
            features.utilization_dashboards &&
            permissionsMap["MENU_HOME_DEVICE_UTILIZATION_KPI_LIST"],
          to: "/utilization",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_DEVICE_UTILIZATION_KPI_LIST_description_key,
          subPages: ["/utilization_graph_and_list"],
        },
      ],
    },
    {
      collapse: true,
      name: language.custom_data_key,
      state: "openCustomData",
      icon: <span className="custom-data-menu-icon menu-icon"></span>,
      view: permissionsMap["MENU_HOME_CUSTOM_DATA_LIST"],
      views: [],
    },
    {
      collapse: true,
      title: language.manage_processes_key,
      name: (
        <>
          {language.manage_processes_key}
          <SntLabIcon
            size={14}
            className={"ms-3"}
            title={language.lab_feature_key}
          />
        </>
      ),
      state: "openProcesses",
      icon: <span className="flow-circle-menu-icon menu-icon"></span>,
      view: organisation?.organisationType !== "SYSTEM",
      views: [
        {
          view:
            features["process_manager"] &&
            permissionsMap["MENU_HOME_PROCESS_LIST"],
          to: "/processes",
          layout: "",
          name: language.process_list_key,
          subPages: ["/process_statistics"],
        },
      ],
    },
    {
      collapse: true,
      name: language.maintenance_key,
      state: "openMaintenances",
      icon: <span className="maintenance-menu-icon menu-icon"></span>,
      view: organisation?.organisationType !== "SYSTEM",
      views: [
        {
          view:
            features.maintenance_basic &&
            permissionsMap["MENU_HOME_MAINTENANCE_OVERVIEW"],
          to: "/maintenance_dashboard",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_MAINTENANCE_OVERVIEW_description_key,
        },
        {
          view:
            features["maintenance_basic"] &&
            permissionsMap["MENU_HOME_MAINTENANCE_PROGRAMS"],
          to: "/maintenance_programs_stats",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_MAINTENANCE_PROGRAMS_description_key,
          subPages: [
            "/maintenance_programs_details",
            "/start_maintenance_program",
          ],
        },
        {
          view:
            features.maintenance_basic &&
            permissionsMap["MENU_HOME_UPCOMING_MAINTENANCE"],
          to: "/maintenance_upcoming",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_UPCOMING_MAINTENANCE_description_key,
        },
        {
          view:
            features.maintenance_basic &&
            permissionsMap["MENU_HOME_DONE_MAINTENANCE"],
          to: "/maintenance_done",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_DONE_MAINTENANCE_description_key,
        },
      ],
    },
    {
      collapse: true,
      name: language.alerts_key,
      state: "openAlerts",
      icon: <span className="alerts-menu-icon menu-icon"></span>,
      view: organisation?.organisationType !== "SYSTEM",
      views: [
        {
          view:
            features.alert_activedb &&
            permissionsMap["MENU_HOME_ALERT_ACTIVE_DASHBOARD"],
          to: "/active_alerts_dashboard",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_ALERT_ACTIVE_DASHBOARD_description_key,
        },
        {
          view:
            features.alert_activelist &&
            permissionsMap["MENU_HOME_ALERT_ACTIVE_LIST"],
          to: "/active_alerts_list",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_ALERT_ACTIVE_LIST_description_key,
        },
        {
          view:
            features.alert_histdb &&
            permissionsMap["MENU_HOME_ALERT_HISTORICAL_DASHBOARD"],
          to: "/historical_alerts_dashboard",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_ALERT_HISTORICAL_DASHBOARD_description_key,
        },
        {
          view:
            features.alert_histlist &&
            permissionsMap["MENU_HOME_ALERT_HISTORICAL_LIST"],
          to: "/historical_alerts_list",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_ALERT_HISTORICAL_LIST_description_key,
        },
      ],
    },
    {
      collapse: true,
      name: language.reports_key,
      state: "openReports",
      icon: <span className="report-menu-icon menu-icon"></span>,
      views: [
        {
          view:
            features.report_generator &&
            permissionsMap["MENU_HOME_REPORT_LIST"],
          to: "/reports",
          layout: "",
          name: language.UserPermission_MENU_HOME_REPORT_LIST_description_key,
          subPages: ["/create_report"],
        },
        {
          view:
            features.report_generator &&
            permissionsMap["MENU_HOME_REPORT_SCHEDULES"],
          to: "/report_schedule",
          layout: "",
          name:
            language.UserPermission_MENU_HOME_REPORT_SCHEDULES_description_key,
        },
      ],
    },
  ];
  const [routes, setRoutes] = useState(initialRoutes);
  const [firstInit, setFirstInit] = useState(true);
  const [data, setData] = useState({
    type: MenuType.MAIN,
    loading: true,
    routes: [],
    availableMenuPaths: {},
    allPaths: {},
    defaultPath: "/tracked_assets",
  });

  const availibleMenuData = useAvailibleMenu(routes, "/tracked_assets");

  useEffect(() => {
    if (firstInit) return;
    setData({ ...data, ...availibleMenuData, loading: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [availibleMenuData, firstInit]);

  useEffect(() => {
    setData({ ...data, loading: true });
    let dashboardViews = [
      {
        view: features.utilization_suez,
        to: "/suez_dashboard",
        layout: "",
        name: language.suez_dashboard_key,
        category: "dashboard",
      },
    ];

    if (features.dashboard && permissionsMap["DASHBOARD_VIEW"]) {
      biClient
        .getDashBoardsForMenu()
        .then((data) => {
          let dashboards = data.data;

          for (let i = 0; i < dashboards.length; i++) {
            dashboardViews.push({
              view: features.dashboard && permissionsMap["MENU_HOME_DASHBOARD"],
              to: "/bi_dashboard/" + dashboards[i].id,
              layout: "",
              type: "bi",
              name: dashboards[i].menuName,
              reportType: dashboards[i].powerBiReportType,
              category: "dashboard",
            });
          }
          updateDashBoardViews(dashboardViews);
        })
        .catch(() => {
          updateDashBoardViews(dashboardViews);
        });
    } else {
      updateDashBoardViews(dashboardViews);
    }

    // Fetch channels for custom data menu
    if (permissionsMap["MENU_HOME_CUSTOM_DATA_LIST"]) {
      channelClient
        .findByOrg(organisation?.id)
        .then((response) => {
          let channels = response.data;
          updateCustomDataViews(channels);
        })
        .catch(() => {
          updateCustomDataViews([]);
        });
    } else {
      updateCustomDataViews([]);
    }

    // Fetch site maps for home menu
    if (features["loc_site_map"] && permissionsMap["MENU_HOME_SITE_MAP"]) {
      sitemapAPI
        .getByOrg({ orgId: organisation?.id })
        .then((response) => {
          let siteMaps = response.data?.data || [];
          updateSiteMapViews(siteMaps);
        })
        .catch(() => {
          updateSiteMapViews([]);
        });
    } else {
      updateSiteMapViews([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [global.reloadSidebar]);

  useEffect(() => {
    setSideBarColors(custumInfo);
  }, [custumInfo]);

  function updateDashBoardViews(dashboardViews) {
    dashboardViews.push({
      view: features.dashboard && permissionsMap["MENU_HOME_DASHBOARD"],
      to: "/all_dashboards",
      layout: "",
      type: "bi",
      name: language.all_dashboards_key,
      category: "dashboard",
    });
    setRoutes((oldRoutes) => {
      let route = oldRoutes.find((x) => x.state === "openDashboards");
      route.views = [];
      route.views.push(...dashboardViews);
      return [...oldRoutes];
    });
    setFirstInit(false);
    onMenuChange();
  }

  function updateCustomDataViews(channels) {
    let customDataViews = [];

    // Add a menu item for each channel that has showInHomeMenu enabled
    const visibleChannels = channels.filter(
      (channel) => channel.showInHomeMenu
    );

    for (let i = 0; i < visibleChannels.length; i++) {
      const channel = visibleChannels[i];
      customDataViews.push({
        view: permissionsMap["MENU_HOME_CUSTOM_DATA_LIST"],
        to: "/custom_data_channel/" + channel.id,
        layout: "",
        type: "channel",
        name: channel.homeMenuItemName || channel.displayName || channel.name,
        channelId: channel.id,
        category: "customData",
      });
    }

    setRoutes((oldRoutes) => {
      // Remove Custom Data section if no visible channels, otherwise update views
      if (visibleChannels.length === 0) {
        return oldRoutes.filter((x) => x.state !== "openCustomData");
      } else {
        let route = oldRoutes.find((x) => x.state === "openCustomData");
        if (route) {
          route.views = [];
          route.views.push(...customDataViews);
        }
        return [...oldRoutes];
      }
    });
    onMenuChange();
  }

  function updateSiteMapViews(siteMaps) {
    setRoutes((oldRoutes) => {
      // If no site maps exist, remove the entire Site maps section
      if (siteMaps.length === 0) {
        return oldRoutes.filter((x) => x.state !== "openSiteMaps");
      }

      let siteMapViews = [];

      // Add menu items for site maps with showInHomeMenu enabled (above "All site maps")
      const visibleSiteMaps = siteMaps.filter(
        (siteMap) => siteMap.showInHomeMenu
      );

      for (let i = 0; i < visibleSiteMaps.length; i++) {
        const siteMap = visibleSiteMaps[i];
        siteMapViews.push({
          view: permissionsMap["MENU_HOME_SITE_MAP"],
          to: "/site_map_view/" + siteMap.id,
          layout: "",
          type: "sitemap",
          name: siteMap.homeMenuItemName || siteMap.name,
          siteMapId: siteMap.id,
          category: "siteMap",
        });
      }

      // Add "All site maps" at the end
      // excludeSubPages prevents "All site maps" from being highlighted when viewing
      // a site map that has its own menu item in the home menu
      siteMapViews.push({
        view:
          features["loc_site_map"] && permissionsMap["MENU_HOME_SITE_MAP"],
        to: "/all_site_maps",
        layout: "",
        name: language.all_site_maps_key,
        subPages: ["/site_map_view"],
        excludeSubPages: visibleSiteMaps.map((sm) => "/site_map_view/" + sm.id),
      });

      let route = oldRoutes.find((x) => x.state === "openSiteMaps");
      if (route) {
        route.views = [];
        route.views.push(...siteMapViews);
      }
      return [...oldRoutes];
    });
    onMenuChange();
  }

  return data;
};

export default useMainMenu;
